import React, { Component } from 'react';

export default class Footer extends Component {
  render() {
    return (
      <div>
        <footer className="footer">
          <div className="container-fluid">
            <div className="row align-items-center justify-content-lg-between">
              <div className="col-lg-6">
                <div className="copyright text-center text-lg-left text-muted">
                  © 2019{" "}
                  <a href="https://sisfomedika.com" className="font-weight-bold ml-1" target="_blank" rel="noopener noreferrer">
                    Sisfomedika
                  </a>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}
